import { writeRichText } from "./clipboard";

/** Tabelle als Tab-getrennten Plaintext (Fallback + text/plain-Variante). */
export function tableToText(table: HTMLTableElement): string {
  const rows = Array.from(table.querySelectorAll("tr"));
  return rows
    .map((r) =>
      Array.from(r.querySelectorAll("th,td"))
        .map((c) => (c.textContent ?? "").trim())
        .join("\t"),
    )
    .join("\n");
}

/**
 * Schreibt die Tabelle als Rich-Text (text/html) **und** Plaintext ins Clipboard,
 * sodass Word/Outlook die formatierte Tabelle einfügen. Fällt auf reinen Text
 * zurück, wenn die Rich-Text-Clipboard-API nicht verfügbar ist.
 */
export async function copyTableToClipboard(table: HTMLTableElement): Promise<void> {
  await writeRichText(table.outerHTML, tableToText(table));
}
